import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { environment } from '../../environments/environment';

// OJO: el `FirebaseApp` de la API "compat" (el que da AngularFireModule.initializeApp)
// y el `FirebaseApp` de la API modular (@angular/fire/app) son tokens de inyección
// DISTINTOS, aunque se llamen igual — por eso esto se queda tal cual (no cambiar a
// provideFirebaseApp()). El problema real de NG0203 con Angular 19+
// (angular/angularfire#3621) se resuelve envolviendo cada llamada a los servicios
// compat en runInInjectionContext() en el punto donde se usan (ver auth.service.ts,
// db.service.ts, analytics.service.ts, upload.service.ts), no acá.
//
// AngularFireAnalyticsModule/AngularFireDatabaseModule/AngularFireStorageModule se
// quitaron de los imports: AngularFireAnalytics y AngularFireStorage (las clases que
// sí se usan, en analytics.service.ts y upload.service.ts) son providedIn:'root' —
// no necesitan el wrapper del módulo. El módulo de Analytics en particular instancia
// de forma anticipada ScreenTrackingService/UserTrackingService (fuera de un
// contexto de inyección válido), lo que tumbaba el arranque con "No provider found
// for FirebaseApp" — mismo bug ya diagnosticado en sinmente/admin. Nada del negocio
// depende de esos dos servicios de auto-tracking. AngularFireDatabase (Realtime
// Database) no se usa en ningún lado del código, así que ese módulo se quita del
// todo.
@NgModule({
  exports: [
    AngularFireModule,
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
  ]
})
export class FirestoreModule { }
